export default {
	OPEN: 'OPEN',
	SUBMITTED_CLIENT: 'SUBMITTED_CLIENT',
	SUBMITTED_EMPLOYEE: 'SUBMITTED_EMPLOYEE',
	EXTERNAL_SUBMIT: 'EXTERNAL_SUBMIT'
};
